import { FormBase } from "../../../util/form-base-form";

export class TabSliderForm extends FormBase {
    public root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public static getRoots(root: ParentNode | Document | HTMLElement = document): HTMLElement[] {
        const form = new TabSliderForm(root instanceof HTMLElement ? root : document.body);
        const roots: HTMLElement[] = [];
        if (root instanceof HTMLElement && root.matches('[data-component="tab-slider"]')) {
            roots.push(root);
        }
        form.queryElements(root, '[data-component="tab-slider"]', HTMLElement).forEach((node) => {
            if (!roots.includes(node)) {
                roots.push(node);
            }
        });
        return roots;
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public getTrack(): HTMLElement | null {
        return this.queryElement(this.root, ".tab-slider__track", HTMLElement);
    }

    public getPrevButton(): HTMLButtonElement | null {
        return this.queryElement(this.root, ".tab-slider__nav--prev", HTMLButtonElement);
    }

    public getNextButton(): HTMLButtonElement | null {
        return this.queryElement(this.root, ".tab-slider__nav--next", HTMLButtonElement);
    }

    public getActiveTab(): HTMLElement | null {
        const track = this.getTrack();
        if (!(track instanceof HTMLElement)) return null;

        return (
            this.queryElement(track, ".tab-slider__tab.is-active", HTMLElement) ||
            this.queryElement(track, '.tab-slider__tab[aria-selected="true"]', HTMLElement)
        );
    }

    public getClosestTab(target: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(target, ".tab-slider__tab", HTMLElement);
    }

    public isInitialized(): boolean {
        return this.root.dataset.tabSliderInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.tabSliderInit = "1";
    }
}
